import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EdFormSmallComponent} from './forms/ed-form-small/ed-form-small.component';
import {SharedModule} from '@shared/shared.module';
import {EdFormMediumComponent} from './forms/ed-form-medium/ed-form-medium.component';
import {EdTestListItemComponent} from './tests/ed-test-list-item/ed-test-list-item.component';
import {
  EdFitMedProfileSmallComponent
} from './fitmedprofiles/ed-fit-med-profile-small/ed-fit-med-profile-small.component';
import {
  EdFitMedProfileMediumComponent
} from './fitmedprofiles/ed-fit-med-profile-medium/ed-fit-med-profile-medium.component';
import {RouterModule} from '@angular/router';
import {
  EdFitMedProfileExtrasmallComponent
} from './fitmedprofiles/ed-fit-med-profile-extrasmall/ed-fit-med-profile-extrasmall.component';
import {ReferralListItemComponent} from './referrals/referral-list-item/referral-list-item.component';
import { NotificationSmallComponent } from './notifications/notification-small/notification-small.component';


@NgModule({
    exports: [
        EdFormSmallComponent,
        EdFormMediumComponent,
        EdTestListItemComponent,
        EdFitMedProfileSmallComponent,
        EdFitMedProfileMediumComponent,
        EdFitMedProfileExtrasmallComponent,
        ReferralListItemComponent,
        NotificationSmallComponent,
    ],
    imports: [
        CommonModule,
        SharedModule.forChild(),
        RouterModule,
        EdFormSmallComponent,
        EdFormMediumComponent,
        EdTestListItemComponent,
        EdFitMedProfileSmallComponent,
        EdFitMedProfileMediumComponent,
        EdFitMedProfileExtrasmallComponent,
        ReferralListItemComponent,
        NotificationSmallComponent
    ]
})
export class EntityDetailComponentsModule {
}
